import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";

import { myGlobals, myUtilities } from "../../Utils";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { callReduxAlertAction, globalVars } from "../../App";

import { PaymentLoader } from "./";
import AlertConfirmDialog from "../Common/AlertConfirmDialog";

class PayButton extends React.Component {
  paymentFailed = (payData) => {
    payData.setPaymentFailed();
  };

  paymentCompleted = async (data, payData) => {
    let splitIdSet = new Set();
    let splitIdString = "";
    for (let i = 0; i < data.rows.length; ++i) {
      if (null !== data.rows[i].splitId && undefined !== data.rows[i].splitId)
        splitIdSet.add(data.rows[i].splitId);
    }
    if (splitIdString.localeCompare("") === 0) {
      if (
        null !== data.rows[0].splitPaymentId &&
        undefined !== data.rows[0].splitPaymentId
      )
        splitIdSet.add(data.rows[0].splitPaymentId);
    }
    splitIdSet.forEach((splitId) => {
      splitIdString += splitId + ",";
    });
    splitIdString = splitIdString.substring(0, splitIdString.length - 1);
    await payData.setPaymentData(data.rows[0].paymentId, splitIdString);
    myGlobals.ACHPaymentCompleted = true;
    myGlobals.getHistory.replace(`/completepaymentACH`);
  };

  openDIPage = (data) => {
    globalVars.sepaDIPageConfigs = data.rows;
    myGlobals.selectedStateMethodPaymentContainer("SEPADI");
  };

  sepaResponseHandler = (
    data,
    invData,
    payData,
    paymentCompleted,
    paymentFailed,
    openDIPage
  ) => {
    let pkCustomerBankAccountId = data;
    const searchParams = new URLSearchParams();
    let invoices = invData.state.selectedInvoices;
    let invoiceList = invoices.map(
      (invoice) =>
        invoice.accountDocHeaderId +
        "@" +
        invoice.payableAmount2 +
        "@" +
        invoice.disputeAmount +
        "@" +
        invoice.reasonCodeId
    );
    searchParams.append(
      "pkCustomerBankAccountId",
      window.rsaEncrypt(pkCustomerBankAccountId)
    );
    searchParams.append(
      "onDemandAccountId",
      window.rsaEncrypt(invData.state.onDemandAccountId)
    );
    searchParams.append("invoiceNumbers", window.rsaEncrypt(invoiceList));
    searchParams.append(
      "pkMapCustomerAccountRad",
      window.rsaEncrypt(invData.state.pkMcarId)
    );
    searchParams.append(
      "globalAccountId",
      window.rsaEncrypt(invData.state.globalAccountId)
    );
    searchParams.append("currency", window.rsaEncrypt(invData.state.currency));
    searchParams.append(
      "customerMapId",
      window.rsaEncrypt(invData.state.pkMcarId)
    );
    searchParams.append(
      "ibanNumber",
      window.rsaEncrypt(payData.state.bankAccNo)
    );
    searchParams.append(
      "accountHolderName",
      window.rsaEncrypt(payData.state.accountName)
    );
    searchParams.append("token", myGlobals.token);
    searchParams.append('publicKeyUI', invData.state.publicKey);

    let link = "payInvoicesThroughSepaACH";
    link = myGlobals.initialHost + myGlobals.appender + link;

    if (
      pkCustomerBankAccountId === null ||
      pkCustomerBankAccountId.trim().length === 0
    ) {
      fetch(link, {
        method: "POST",
        body: searchParams,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          return response.json();
        })
        .then(function (data) {
          
          if(data != undefined && data.rows != undefined && data.rows.failureReason && data.rows.failureReason === 'LINK_EXPIRED'){
            myGlobals.errorMessage = myUtilities.accountSpecificLanguage("Error.LinkExpired", "Link has expired");
            myGlobals.getHistory.replace(`/linkExpired`);
            return;
          }

          console.log("success");
          console.log(data);
          openDIPage(data);
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          paymentFailed(payData);
        });
    } else {
      //"https://api.jsonbin.io/b/5e58ec9209ac43054813b71b"
      fetch(link, {
        method: "POST",
        body: searchParams,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          return response.json();
        })
        .then(function (data) {
          paymentCompleted(data, payData);
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          paymentFailed(payData);
        });
    }
  };

  sepaOnClick = (
    payData,
    invData,
    responseFunction,
    paymentCompleted,
    paymentFailed,
    openDIPage
  ) => {
    const searchParams = new URLSearchParams();
    searchParams.append(
      "ibanNumber",
      window.rsaEncrypt(payData.state.bankAccNo)
    );
    searchParams.append(
      "customerMapId",
      window.rsaEncrypt(invData.state.pkMcarId)
    );
    searchParams.append(
      "onDemandAccountId",
      window.rsaEncrypt(invData.state.onDemandAccountId)
    );
    searchParams.append(
      "accountHolderName",
      window.rsaEncrypt(payData.state.accountName)
    );
    console.log("bank account number", payData.state.bankAccNo);
    if (
      payData.state.bankAccNo === null ||
      payData.state.bankAccNo.toString().trim().length === 0 ||
      payData.state.accountName.trim().length === 0
    ) {
      callReduxAlertAction(
        "SepaForm.Mandate.Alert",
        "Please input the mandatory payment details before proceeding"
      );
    } else {
      let link = "getCustomerBankAccount";

      link = myGlobals.initialHost + myGlobals.appender + link;
      //'https://5e58f54f0eab3.htmlsave.com/'
      fetch(link, {
        method: "POST",
        body: searchParams,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          return response.text();
        })
        .then(function (data) {
          responseFunction(
            data,
            invData,
            payData,
            paymentCompleted,
            paymentFailed,
            openDIPage
          );
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          //onFailure(err);
        });
    }
  };

  onClick = (payData, invData) => {
    this.onClickTh(payData, invData);
  };
  onClickTh = async (payData, invData) => {
    await payData.setState({
      formRef: true,
    });
    if (payData.state.allowSubmit) payData.setDataForSendingOldACH(invData);
  };
  onClickRenderer = (invData, paymentData) => {
    if (invData.state.isSepa)
      return this.sepaOnClick(
        paymentData,
        invData,
        this.sepaResponseHandler,
        this.paymentCompleted,
        this.paymentFailed,
        this.openDIPage
      );
    else return this.onClick(paymentData, invData);
  };
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(invData) => (
          <Subscribe to={[PaymentDataContainer]}>
            {(data) => (
              <Col>
                <Container>
                  <Row>
                    <Col className="pay-button-container">
                      <PaymentLoader />
                        <AlertConfirmDialog
                          onAlertConfirmDialogClick={myGlobals.handleConfirmClick}/>

                          <button
                            type="submit"
                            className="pay-button mainapp-button"
                            value="Pay"
                          >
                            {myUtilities.accountSpecificLanguage("pay", "Pay")}
                          </button>
                   
                    </Col>
                  </Row>
                </Container>
              </Col>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
  componentDidMount() {
    myGlobals.handleACHFormSubmit = this.onClickRenderer;
  }
}

export default PayButton;
